import { render, staticRenderFns } from "./DetailVideoPhoto.vue?vue&type=template&id=2ed3a690&scoped=true&lang=pug&"
import script from "./DetailVideoPhoto.vue?vue&type=script&lang=js&"
export * from "./DetailVideoPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DetailVideoPhoto.vue?vue&type=style&index=0&id=2ed3a690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed3a690",
  null
  
)

export default component.exports